import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xl-12 col-xm-12" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_5 = { class: "border p-2 p-lg-4 border-dark border-opacity-10" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12 col-xl-12 col-xm-12" }
const _hoisted_8 = {
  for: "contrat",
  class: "form-label fw-medium text-black"
}
const _hoisted_9 = { class: "col-md-6 col-xl-6 col-xm-12" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "col-md-3 col-xl-3 col-xm-12" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "col-md-3 col-xl-3 col-xm-12" }
const _hoisted_14 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_15 = { class: "card-footer text-md-end text-xl-end text-sm-center p-15 p-sm-20 p-md-25 p-lg-30 bg-white" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_AddUsagerModal = _resolveComponent("AddUsagerModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Form, {
            ref: "redeForm",
            onSubmit: _ctx.payer,
            "validation-schema": _ctx.usagerSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _cache[11] || (_cache[11] = _createElementVNode("h5", { class: "card-title fw-bold mb-15 mb-lg-20 mb-xl-25" }, null, -1)),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", null, " Usager", -1)),
                        _createElementVNode("span", null, [
                          _createElementVNode("a", {
                            href: "#",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddUsagerModal",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.ajouterUsager && _ctx.ajouterUsager(...args))),
                            type: "button"
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("span", {
                              class: "badge text-bg-success",
                              style: {"margin-left":"0.3em"}
                            }, "A", -1)
                          ]))]),
                          _createElementVNode("a", {
                            href: "#",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#AddUsagerModal",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modifUsager && _ctx.modifUsager(...args))),
                            type: "button"
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("span", {
                              class: "badge text-bg-secondary ml-5",
                              style: {"margin-left":"0.3em"}
                            }, "M", -1)
                          ]))])
                        ])
                      ]),
                      _createVNode(_component_Field, {
                        name: "usager",
                        modelValue: _ctx.usager,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.usager) = $event)),
                        class: "form-control shadow-none fs-md-15 text-black"
                      }, {
                        default: _withCtx(({ field }) => [
                          _createVNode(_component_Multiselect, _mergeProps({
                            modelValue: field.value,
                            "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                          }, field, {
                            "filter-results": false,
                            "min-chars": 2,
                            "resolve-on-load": false,
                            delay: 0,
                            searchable: true,
                            "options-limit": 300,
                            options: 
                        async (query) => {
                          if (query.length >= 3) {
                            const results = await _ctx.reupererUsagers(query);
                            if (results && results.length > 0) {
                              return results;
                            } else if (results.length >= 3) {
                              return [
                                {
                                  value: '',
                                  label: 'Aucun enregistrement trouvé',
                                },
                              ];
                            } else {
                              return [];
                            }
                          }
                        }
                      ,
                            noOptionsText: "Tapez au moins deux caractères",
                            placeholder: "Rechercher un contrat"
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "usager",
                        class: "text-danger"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Payable ", -1)),
                        _createVNode(_component_Field, {
                          name: "mois",
                          modelValue: _ctx.mois,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.mois) = $event))
                        }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              mode: "tags",
                              multiple: true,
                              options: _ctx.moiss,
                              searchable: true,
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Sélectionner les mois à payer" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "mois",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _cache[9] || (_cache[9] = _createElementVNode("label", {
                          for: "montant",
                          class: "form-label fw-medium text-black"
                        }, " Montant ", -1)),
                        _createVNode(_component_Field, {
                          name: "montant",
                          modelValue: _ctx.montant,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.montant) = $event)),
                          disabled: true,
                          class: "form-control shadow-none fs-md-15 text-black"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_ErrorMessage, {
                          name: "montant",
                          class: "text-danger"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label fw-medium text-black" }, " Mode de paiement ", -1)),
                        _createVNode(_component_Field, { name: "mode" }, {
                          default: _withCtx(({ field }) => [
                            _createVNode(_component_Multiselect, _mergeProps({
                              options: _ctx.modes,
                              multiple: false,
                              searchable: true,
                              modelValue: field.value,
                              "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                            }, field, { placeholder: "Sélectionner un mode" }), null, 16, ["options", "modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ErrorMessage, {
                          name: "mode",
                          class: "text-danger"
                        })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _cache[13] || (_cache[13] = _createElementVNode("button", {
                  class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success",
                  type: "submit"
                }, " Payer ", -1)),
                _createVNode(_component_router_link, {
                  to: "/liste-paiement",
                  class: "btn btn-danger transition border-0 lh-1 fw-medium"
                }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1),
                    _createElementVNode("span", { class: "position-relative" }, null, -1),
                    _createTextVNode("Annuler ", -1)
                  ]))]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ]),
    _createVNode(_component_AddUsagerModal, {
      item: _ctx.selectedItem,
      onClose: _ctx.recharger,
      onRecuperation: _ctx.recuperation,
      onOpen: _ctx.show_Modal
    }, null, 8, ["item", "onClose", "onRecuperation", "onOpen"])
  ], 64))
}